import CartButton from "@modules/layout/header/cart-button";
import Search from "@modules/layout/header/search";
import { ICON_SIZE, IconButton } from "@shared/components/icon-button";
import SubscriptionBanner from "@shared/components/subscription-banner";
import useGoBack from "@shared/hooks/useGoBack";
import ArrowRightIcon from "@svg/new-design/arrow-right";
import { useAccess } from "@templates/course/hooks/useAccess";
import classNames from "classnames";
import { FC } from "react";

const MobileHeader: FC = () => {
  const { isAdmin, shouldRenderSubscriptionTopBanner } = useAccess();
  const backHandler = useGoBack();

  return (
    <div
      className={classNames(
        "md:hidden sticky left-0   bg-white z-[100] shadow-sm ",
        isAdmin ? "top-[50px]" : "top-0"
      )}
    >
      {shouldRenderSubscriptionTopBanner && (
        <SubscriptionBanner className="flex relative inset-x-0 lg:hidden z-50 top-0" />
      )}
      <div className="justify-between  flex p-2  items-center h-14 w-full gap-x-1">
        <div className="flex w-full gap-x-1 items-center">
          <IconButton
            icon={<ArrowRightIcon />}
            size={ICON_SIZE.MEDIUM}
            onClick={backHandler}
            aria-label="بازگشت به صفحه قبل"
          />
          <Search isAdmin={isAdmin} open={true} />
        </div>
        <div className="flex gap-x-1">
          <div className="flex items-center">
            <CartButton />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileHeader;
